var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: "translate(-0.2px, 0.7px)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.65188 3.36898L4.54574 3.47507L4.65188 3.58116L6.33976 5.26827C6.6214 5.56041 6.61858 6.01326 6.34069 6.29103C6.1956 6.43605 6.01312 6.50324 5.82944 6.50324C5.64576 6.50324 5.46328 6.43605 5.31819 6.29103L3.62938 4.60299L3.52334 4.497L3.4173 4.60299L1.6819 6.3376C1.53682 6.48262 1.35434 6.5498 1.17066 6.5498C0.98698 6.5498 0.804498 6.48262 0.659412 6.3376C0.380261 6.05858 0.380261 5.59479 0.659412 5.31576L2.39481 3.58116L2.50095 3.47507L2.39481 3.36898L0.706 1.68094C0.426849 1.40191 0.426849 0.938125 0.706 0.659101C0.985188 0.380039 1.4493 0.380039 1.72849 0.659101L3.4173 2.34714L3.52334 2.45313L3.62938 2.34714L5.25996 0.717309C5.53915 0.438248 6.00326 0.438248 6.28245 0.717309C6.5616 0.996333 6.5616 1.46012 6.28245 1.73914L4.65188 3.36898Z",
    fill: "#6000E9",
    stroke: "#AC79F6",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/no.d8097c8ca376e148004c1c2723615932.svg";
export { ForwardRef as ReactComponent };